module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar-crop flex flex-column"
  }, [_c('div', {
    staticClass: "wrapper flex flex-1 flex-main-center flex-cross-center"
  }, [(_vm.defaultImage) ? _c('div', {
    staticClass: "image",
    style: ({
      'background-image': ("url('" + (_vm.croppedImage||_vm.defaultImage) + "')")
    })
  }) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "upload",
    attrs: {
      "type": "file",
      "accept": _vm.accept
    },
    on: {
      "change": _vm.fileChange
    }
  }), _vm._v(" "), (_vm.showCropDialog) ? _c('div', {
    staticClass: "crop flex flex-main-center flex-cross-center",
    attrs: {
      "transition": "crop"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dialog",
    style: ({
      width: _vm.width + 'px'
    })
  }, [_c('section', {
    class: {
      grab: !_vm.grabbing, grabbing: _vm.grabbing
    },
    style: ({
      height: _vm.height + 'px'
    })
  }, [(_vm.showCircle) ? _c('div', {
    staticClass: "img-circle"
  }) : _vm._e(), _vm._v(" "), _c('img', {
    style: ({
      width: _vm.scaleWidth + 'px',
      height: _vm.scaleHeight + 'px',
      left: _vm.scaleX + 'px',
      top: _vm.scaleY + 'px'
    }),
    attrs: {
      "src": _vm.img ? _vm.img.src : null
    },
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        _vm.cropDragBegin($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        _vm.cropDragMove($event)
      },
      "touchend": function($event) {
        $event.preventDefault();
        _vm.cropDragEnd($event)
      }
    }
  })]), _vm._v(" "), _c('footer', {
    staticClass: "flex flex-main-center vux-1px-t"
  }, [_c('button', {
    staticClass: "btn flex-1 vux-1px-r",
    on: {
      "click": _vm.cropCancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))]), _vm._v(" "), _c('button', {
    staticClass: "btn flex-1",
    on: {
      "click": _vm.cropOK
    }
  }, [_vm._v(_vm._s(_vm.okText))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scale),
      expression: "scale"
    }],
    staticClass: "scale",
    attrs: {
      "type": "range",
      "value": "100",
      "min": "100",
      "max": "200",
      "step": "1"
    },
    domProps: {
      "value": (_vm.scale)
    },
    on: {
      "input": _vm.cropZoom,
      "__r": function($event) {
        _vm.scale = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "tips"
  }, [_vm._v("点击更改头像")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "v-beat v-beat-odd"
  }), _vm._v(" "), _c('div', {
    staticClass: "v-beat v-beat-even"
  }), _vm._v(" "), _c('div', {
    staticClass: "v-beat v-beat-odd"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a5f6208","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AvatarCrop.vue
// module id = 248
// module chunks = 6